import PropTypes from 'prop-types';
import { BugAntIcon } from '@heroicons/react/24/solid';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import toast from 'react-hot-toast';
import http from '../api/http';

const ErrorBoundaryComponent = ({ error, resetErrorBoundary }) => {
  const navigate = useNavigate();
  const handleGoToHomePage = () => {
    navigate('/dashboard', {
      replace: true,
    });
    window.location.reload();
  };
  useEffect(() => {
    (async () => {
      try {
        await http.post('/frontend/errorlogs', {
          description: error.stack,
        });
        toast.success('Error reporting send successfully');
      } catch (error) {
        toast.error('Error reporting not send');
      }
    })();
  }, [error]);
  return (
    <section className="min-h-screen bg-white">
      <div className="max-w-screen-xl px-4 py-8 mx-auto lg:py-16 lg:px-6">
        <div className="flex flex-col items-center justify-center max-w-screen-sm mx-auto text-center">
          <BugAntIcon className="my-3 fa-bug w-36 h-36" />
          <p className="mb-4 text-3xl font-bold tracking-tight text-gray-900 md:text-4xl">
            Something went wrong.
          </p>
          <p className="mb-4 text-lg font-light text-gray-500">
            Oops, something went wrong.Try to refresh this page or click the
            button below to go to the home page. {error.message}
          </p>
          <div className="flex justify-between space-x-5">
            <button
              type="button"
              onClick={handleGoToHomePage}
              className="inline-flex text-white bg-gray-600 hover:bg-gray-800 focus:ring-0 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center my-4 cursor-pointer"
            >
              Back to Homepage
            </button>
            <button
              type="button"
              onClick={resetErrorBoundary}
              className="inline-flex text-white bg-blue-600 hover:bg-blue-800 focus:ring-0 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center my-4 cursor-pointer"
            >
              Reload Page
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

ErrorBoundaryComponent.defaultProps = {
  resetErrorBoundary: {},
  error: null,
};

ErrorBoundaryComponent.propTypes = {
  resetErrorBoundary: PropTypes.func,
  error: PropTypes.oneOfType([PropTypes.any]),
};

export default ErrorBoundaryComponent;
